import ApiService from '@/helpers/api.service.ext';

const API = new ApiService();

const ENDPOINT = 'eload/provider-';

export const state = {
  errors: null,
  tblCount: 0
}

export const mutations = {
  SET_ERROR(state, errors){
    state.errors = errors;
  }
}

export const actions = {
  actionEloadProvider(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/${ENDPOINT}${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  }
}

export const getters = {}